import { i18nTranslate } from 'src/utils/i18n'

const selectLanguageUS = [
  {
    label: i18nTranslate('accountProfile.english', 'English'),
    value: 'English',
  },
  {
    label: i18nTranslate('accountProfile.vietnamese', 'Vietnamese'),
    value: 'Vietnamese',
  },
  {
    label: i18nTranslate('accountProfile.spanish', 'Spanish'),
    value: 'Spanish',
  },
  {
    label: i18nTranslate('accountProfile.chinese', 'Chinese'),
    value: 'Chinese',
  },
]
const selectLanguageCA = [
  {
    label: i18nTranslate('accountProfile.english', 'English'),
    value: 'English',
  },
  {
    label: i18nTranslate('accountProfile.french', 'French'),
    value: 'French',
  },
  {
    label: i18nTranslate('accountProfile.chinese', 'Chinese'),
    value: 'Chinese',
  },
]

const selectLanguageLATAM = [
  {
    label: i18nTranslate('accountProfile.spanish', 'Spanish'),
    value: 'Spanish',
  },
]

const selectAllLanguages = [
  {
    label: i18nTranslate('accountProfile.spanish', 'Spanish'),
    value: 'Spanish',
  },
  {
    label: i18nTranslate('accountProfile.hebrew', 'Hebrew'),
    value: 'Hebrew',
  },
  {
    label: i18nTranslate('accountProfile.ukrainian', 'Ukrainian'),
    value: 'Ukrainian',
  },
  {
    label: i18nTranslate('accountProfile.malay', 'Malay'),
    value: 'Malay',
  },
  {
    label: i18nTranslate('accountProfile.romansh', 'Romansh'),
    value: 'Romansh',
  },
  {
    label: i18nTranslate('accountProfile.german', 'German'),
    value: 'German',
  },
  {
    label: i18nTranslate('accountProfile.english', 'English'),
    value: 'English',
  },
  {
    label: i18nTranslate('accountProfile.dutch', 'Dutch'),
    value: 'Dutch',
  },
  {
    label: i18nTranslate('accountProfile.french', 'French'),
    value: 'French',
  },
  {
    label: i18nTranslate('accountProfile.italian', 'Italian'),
    value: 'Italian',
  },
  {
    label: i18nTranslate('accountProfile.danish', 'Danish'),
    value: 'Danish',
  },
  {
    label: i18nTranslate('accountProfile.swedish', 'Swedish'),
    value: 'Swedish',
  },
  {
    label: i18nTranslate('accountProfile.finnish', 'Finnish'),
    value: 'Finnish',
  },
  {
    label: i18nTranslate('accountProfile.chinese', 'Chinese'),
    value: 'Chinese',
  },
  {
    label: i18nTranslate('accountProfile.hungarian', 'Hungarian'),
    value: 'Hungarian',
  },
  {
    label: i18nTranslate('accountProfile.indonesian', 'Indonesian'),
    value: 'Indonesian',
  },
  {
    label: i18nTranslate('accountProfile.luxembourgish', 'Luxembourgish'),
    value: 'Luxembourgish',
  },
  {
    label: i18nTranslate('accountProfile.portuguese', 'Portuguese'),
    value: 'Portuguese',
  },
  {
    label: i18nTranslate('accountProfile.norwegian', 'Norwegian'),
    value: 'Norwegian',
  },
  {
    label: i18nTranslate('accountProfile.polish', 'Polish'),
    value: 'Polish',
  },
  {
    label: i18nTranslate('accountProfile.russian', 'Russian'),
    value: 'Russian',
  },
  {
    label: i18nTranslate('accountProfile.thai', 'Thai'),
    value: 'Thai',
  },
  {
    label: i18nTranslate('accountProfile.filipino', 'Filipino'),
    value: 'Filipino',
  },
  {
    label: i18nTranslate('accountProfile.vietnamese', 'Vietnamese'),
    value: 'Vietnamese',
  },
  {
    label: i18nTranslate('accountProfile.japanese', 'Japanese'),
    value: 'Japanese',
  },
  {
    label: i18nTranslate('accountProfile.icelandic', 'Icelandic'),
    value: 'Icelandic',
  },
  {
    label: i18nTranslate('accountProfile.maori', 'Maori'),
    value: 'Maori',
  },
  {
    label: i18nTranslate('accountProfile.romanian', 'Romanian'),
    value: 'Romanian',
  },
  {
    label: i18nTranslate('accountProfile.slovak', 'Slovak'),
    value: 'Slovak',
  },
  {
    label: i18nTranslate('accountProfile.bulgarian', 'Bulgarian'),
    value: 'Bulgarian',
  },
  {
    label: i18nTranslate('accountProfile.czech', 'Czech'),
    value: 'Czech',
  },
  {
    label: i18nTranslate('accountProfile.korean', 'Korean'),
    value: 'Korean',
  },
]

const selectGenderUsCa = [
  {
    label: i18nTranslate('accountProfile.selectOne', 'Select One'),
    value: '',
  },
  {
    label: i18nTranslate('accountProfile.male', 'Male'),
    value: 'Male',
  },
  {
    label: i18nTranslate('accountProfile.female', 'Female'),
    value: 'Female',
  },
  {
    label: i18nTranslate(
      'accountProfile.notListed',
      'Not listed / Prefer not to answer'
    ),
    value: 'Not listed / Prefer not to answer',
  },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.woman',
  //       'Woman'
  //     ),
  //   value: 'Woman',
  // },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.man',
  //       'Man'
  //     ),
  //   value: 'Man',
  // },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.transgender',
  //       'Transgender'
  //     ),
  //   value: 'Transgender',
  // },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.nonBinaryNonConforming',
  //       'Non-binary/Non-conforming'
  //     ),
  //   value: 'Non-binary/Non-conforming',
  // },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.other',
  //       'Other'
  //     ),
  //   value: 'Other',
  // },
  // {
  //   label:
  //     i18nTranslate(
  //       'accountProfile.iPreferNotToRespond',
  //       'I prefer not to respond'
  //     ),
  //   value: 'I prefer not to respond',
  // },
]

const selectLanguageEnglishOnly = [
  {
    label: i18nTranslate('accountProfile.english', 'English'),
    value: 'English',
  },
]

const selectLanguageFrenchOnly = [
  {
    label: i18nTranslate('accountProfile.french', 'French'),
    value: 'French',
  },
]

export {
  selectLanguageUS,
  selectLanguageCA,
  selectLanguageLATAM,
  selectAllLanguages,
  selectGenderUsCa,
  selectLanguageEnglishOnly,
  selectLanguageFrenchOnly,
}
